import { forwardRef } from 'react';
import noop from 'utils/noop';
import { ConditionSingleValueDateProps } from '../types';
import { ConditionTriggerButton } from '../TriggerButton';

export const ConditionDatePickerTriggerButton = forwardRef<
  HTMLButtonElement,
  ConditionSingleValueDateProps
>(({ value: date, isEmpty, placeholder, ...props }, ref) => {
  const content = isEmpty ? placeholder : date;
  return (
    <ConditionTriggerButton onClick={noop} innerRef={ref} isEmpty={isEmpty} {...props}>
      {content}
    </ConditionTriggerButton>
  );
});
